import React from 'react';
import { motion } from 'framer-motion';
export function Cta() {
  return <section className="py-32 relative overflow-hidden border-t border-cozy-border bg-white" data-id="element-35">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-pattern opacity-50" data-id="element-36" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cozy-accent/5 rounded-full blur-[80px] pointer-events-none" data-id="element-37" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-39">
          <h2 className="font-serif text-5xl md:text-7xl mb-6 text-cozy-text tracking-tight" data-id="element-40">
            Make your AI feel{' '}
            <span className="italic text-cozy-accent" data-id="element-41">at home.</span>
          </h2>
          <p className="text-xl text-cozy-muted mb-10 max-w-2xl mx-auto" data-id="element-42">
            Join thousands of developers and teams building the next generation
            of context-aware workflows.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-43">
            <a href="#start" className="w-full sm:w-auto bg-cozy-accent text-white px-8 py-4 rounded-full font-medium hover:bg-cozy-accentHover transition-colors shadow-lg shadow-cozy-accent/20 text-lg" data-id="element-44">
              Start building for free
            </a>
            <span className="text-sm text-cozy-muted" data-id="element-45">
              No credit card required.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}